export default [
  {
    path: '/live/meetinglist',
    meta: { title: '小组讨论列表' },
    component: () =>
      import(
        /* webpackChunkName: "meetinglist" */ '../../pages/live/meeting/MeetingList.vue'
      )
  },
  {
    path: '/live/meeting',
    meta: { title: '加载中' },
    component: () =>
      import(
        /* webpackChunkName: "meeting" */ '../../pages/live/meeting/index.vue'
      )
  },
  {
    path: '/live/businesscardlist',
    meta: { title: '我的名片夹' },
    component: () =>
      import(
        /* webpackChunkName: "businesscardlist" */ '../../pages/live/meeting/CardList.vue'
      )
  },
  {
    name: 'Feedback',
    path: '/live/feedback',
    meta: { title: '服务反馈' },
    component: () =>
      import(
        /* webpackChunkName: "feedback" */ '../../pages/live/feedback/index.vue'
      )
  },
  {
    name: 'FeedbackSuccess',
    path: '/live/feedbacksuccess',
    meta: { title: '服务反馈' },
    component: () =>
      import(
        /* webpackChunkName: "feedbacksuccess" */ '../../pages/live/feedback/success.vue'
      )
  },
  {
    name: 'LaunchApp',
    path: '/live/launch-app',
    meta: { title: '唤起APP' },
    component: () =>
      import(
        /* webpackChunkName: "feedbacksuccess" */ '../../pages/live/launchapp/launchapp.vue'
      )
  },
  {
    name: 'questionaireList',
    path: '/questionaireList',
    meta: { title: '调查问卷' },
    component: () =>
      import(
        /* webpackChunkName: "feedbacksuccess" */ '../../pages/questionaire/questionaireList.vue'
      )
  },
  {
    name: 'flow',
    path: '/flow',
    meta: { title: '预估流量' },
    component: () =>
      import(
        /* webpackChunkName: "feedbacksuccess" */ '../../pages/live/flow/index.vue'
      )
  }
]
